module.exports = __webpack_public_path__ + "static/media/ReturnsDriveLogo.e85b5244.png";